import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { shape, string } from 'prop-types';
import LoyaltyCommission from '../../LoyaltyCommission';
import { LoyaltyContainer } from '../product-card.styles';
import { LIST } from '../../../constants';
const loyaltyComponent = {
  sales_commission: LoyaltyCommission,
  sales_dynamic_commission: LoyaltyCommission
};

const Loyalty = ({
  displayMode,
  loyalty,
  productUrl
}) => {
  const LoyaltyComponent = loyaltyComponent[loyalty == null ? void 0 : loyalty.type];
  if (!loyalty) return null;
  return /*#__PURE__*/React.createElement(LoyaltyContainer, {
    displayMode: displayMode
  }, LoyaltyComponent && /*#__PURE__*/React.createElement(LoyaltyComponent, _extends({}, loyalty, {
    productUrl: productUrl
  })));
};

Loyalty.defaultProps = {
  displayMode: LIST,
  loyalty: {},
  productUrl: ''
};
process.env.NODE_ENV !== "production" ? Loyalty.propTypes = {
  displayMode: string,
  productUrl: string,
  loyalty: shape({
    attributes: shape({}),
    description: string,
    label: string,
    type: string,
    value: string
  })
} : void 0;
export default Loyalty;